// src/components/MarketingSection.js
import React from "react";
import { makeStyles } from "@mui/styles";
import { Container } from "@mui/material";
import { CryptoState } from "../CryptoContext";
import moonImage from "../assets/moon.webp";
import { colors, spacing, borderRadius, componentStyles } from "../styles/designSystem";

const useStyles = makeStyles((theme) => ({
  marketingSection: {
    ...componentStyles.sectionContainer,
    background: `url(${moonImage}) no-repeat center center`,
    backgroundSize: "cover",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: colors.text.primary,
    textAlign: "center",
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.3)',
      pointerEvents: 'none',
    },
  },
  
  contentContainer: {
    ...componentStyles.contentContainer,
    position: 'relative',
    zIndex: 2,
  },
  
  content: {
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    padding: spacing.xl,
    borderRadius: borderRadius.xl,
    cursor: "pointer",
    backdropFilter: 'blur(10px)',
    border: `1px solid rgba(255, 255, 255, 0.1)`,
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      transform: 'scale(1.02)',
    },
  },
}));

const MarketingSection = () => {
  const classes = useStyles();
  const { setOpen } = CryptoState();

  const handleOpenModal = () => {
    setOpen(true);
  };

  return (
    <div className={classes.marketingSection} onClick={handleOpenModal}>
      <Container className={classes.contentContainer}>
        <div className={classes.content}>
          <h1>Join our Exclusive Presale!</h1>
          <p>
            Don't miss out on this opportunity to invest in Retro Llama Tokens at
            a discounted rate.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default MarketingSection;
